export default "__VITE_ASSET__Cfdm5HkE__"